// Recorridos 360° publicados, por cámara. Lo lee la pestaña "Recorrido 360°" de cada obra.
//
// Cada entrada: `feeds` = feedID de las cámaras (usuarios.feedID) que lo ven; `obras` = secciones. Una misma cámara
// puede tener varias obras (la de hoy y las que vengan) y cada obra varias capturas (`recorridos`, por fecha).
// Para sumar un 360 nuevo: agregar una captura a la obra que corresponda, o una obra nueva al principio de `obras`.
//   url   = la página 360 (editor.lisual.com/p/<slug>), se ve adentro de la plataforma.
//   video = (opcional) mp4 del recorrido; si está, aparece el botón "Video".
// Armado el 26/10/2026 cruzando las 249 páginas del Editor 2.0 (timelapse/public/pages): las 27 webs con 360 y sus cámaras.
// Cuando la web tiene página "sólo 360" (<slug>360 / <slug>_360) se usa esa: abre directo en el recorrido.
export const RECORRIDOS_360 = [
  {
    "web": "golf293",
    "feeds": [
      "lixcaj920wga"
    ],
    "obras": [
      {
        "id": "golf293",
        "titulo": "Golf · Lote 293, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-10-06",
            "url": "https://editor.lisual.com/p/golf293"
          }
        ]
      }
    ]
  },
  {
    "web": "lote233360",
    "feeds": [
      "liepmxnp3wm3",
      "liao6yvyw408"
    ],
    "obras": [
      {
        "id": "lote233360",
        "titulo": "Lote 233, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-10-06",
            "url": "https://editor.lisual.com/p/lote233360"
          }
        ]
      }
    ]
  },
  {
    "web": "gsg2",
    "feeds": [
      "liqvozse11yv"
    ],
    "obras": [
      {
        "id": "gsg2",
        "titulo": "GSG 2, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-10-05",
            "url": "https://editor.lisual.com/p/gsg2"
          }
        ]
      }
    ]
  },
  {
    "web": "giargia",
    "feeds": [
      "li45q9sytxg4"
    ],
    "obras": [
      {
        "id": "giargia",
        "titulo": "Obra Nagore, Belen de Escobar",
        "recorridos": [
          {
            "fecha": "2026-10-06",
            "url": "https://editor.lisual.com/p/giargia"
          }
        ]
      }
    ]
  },
  {
    "web": "altotesa",
    "feeds": [
      "lilocryuyfwu"
    ],
    "obras": [
      {
        "id": "altotesa",
        "titulo": "Andariega, Nunez (Av. del Libertador)",
        "recorridos": [
          {
            "fecha": "2026-10-14",
            "url": "https://editor.lisual.com/p/altotesa"
          }
        ]
      }
    ]
  },
  {
    "web": "puentes132",
    "feeds": [
      "feracjwqqqho"
    ],
    "obras": [
      {
        "id": "puentes132",
        "titulo": "Puentes · Lote 132, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-10-14",
            "url": "https://editor.lisual.com/p/puentes132"
          }
        ]
      }
    ]
  },
  {
    "web": "puentes246",
    "feeds": [
      "lifbxlb11tzl"
    ],
    "obras": [
      {
        "id": "puentes246",
        "titulo": "Puentes · Lote 246, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-10-14",
            "url": "https://editor.lisual.com/p/puentes246"
          }
        ]
      }
    ]
  },
  {
    "web": "puentes258",
    "feeds": [
      "feiqdguubdfe"
    ],
    "obras": [
      {
        "id": "puentes258",
        "titulo": "Puentes · Lote 258, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-10-14",
            "url": "https://editor.lisual.com/p/puentes258"
          }
        ]
      }
    ]
  },
  {
    "web": "sd3722",
    "feeds": [
      "limee07qeus1"
    ],
    "obras": [
      {
        "id": "sd3722",
        "titulo": "Santos Dumont 3722, Chacarita",
        "recorridos": [
          {
            "fecha": "2026-09-29",
            "url": "https://editor.lisual.com/p/sd3722_360"
          }
        ]
      }
    ]
  },
  {
    "web": "sd3744",
    "feeds": [
      "lierjeze2kqf"
    ],
    "obras": [
      {
        "id": "sd3744",
        "titulo": "Santos Dumont 3744, Chacarita",
        "recorridos": [
          {
            "fecha": "2026-09-29",
            "url": "https://editor.lisual.com/p/sd3744_360"
          }
        ]
      }
    ]
  },
  {
    "web": "teuroc",
    "feeds": [
      "feh0tfth8gc2"
    ],
    "obras": [
      {
        "id": "teuroc",
        "titulo": "Edificio frente a la laguna, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-09-30",
            "url": "https://editor.lisual.com/p/teuroc"
          }
        ]
      }
    ]
  },
  {
    "web": "fralomunro",
    "feeds": [
      "liny0cbmimth",
      "lib54j79dozd"
    ],
    "obras": [
      {
        "id": "fralomunro",
        "titulo": "Esteban Echeverria 4230, Munro",
        "recorridos": [
          {
            "fecha": "2026-09-30",
            "url": "https://editor.lisual.com/p/fralomunro"
          }
        ]
      }
    ]
  },
  {
    "web": "rrezeiza",
    "feeds": [
      "li1stefftw1k"
    ],
    "obras": [
      {
        "id": "rrezeiza",
        "titulo": "Nave LM, Polo Industrial Ezeiza",
        "recorridos": [
          {
            "fecha": "2026-10-01",
            "url": "https://editor.lisual.com/p/rrezeiza"
          }
        ]
      }
    ]
  },
  {
    "web": "fae241",
    "feeds": [
      "liu7ntmdcl8b",
      "li1l64j7h94s"
    ],
    "obras": [
      {
        "id": "fae241",
        "titulo": "Lotes 241 y 242 · Polo Ind. Ezeiza",
        "recorridos": [
          {
            "fecha": "2026-10-01",
            "url": "https://editor.lisual.com/p/fae241"
          }
        ]
      }
    ]
  },
  {
    "web": "faebrasil",
    "feeds": [
      "lizw37hx9lq2"
    ],
    "obras": [
      {
        "id": "faebrasil",
        "titulo": "Calle Brasil, San Telmo",
        "recorridos": [
          {
            "fecha": "2026-10-02",
            "url": "https://editor.lisual.com/p/faebrasil"
          }
        ]
      }
    ]
  },
  {
    "web": "faesalta",
    "feeds": [
      "li1z34bfzf1e"
    ],
    "obras": [
      {
        "id": "faesalta",
        "titulo": "Calle Salta",
        "recorridos": [
          {
            "fecha": "2026-10-02",
            "url": "https://editor.lisual.com/p/faesalta"
          }
        ]
      }
    ]
  },
  {
    "web": "enne",
    "feeds": [
      "lig4xg2qunfn"
    ],
    "obras": [
      {
        "id": "enne",
        "titulo": "Hospital Norpatagonico, Neuquen",
        "recorridos": [
          {
            "fecha": "2026-09-12",
            "url": "https://editor.lisual.com/p/enne"
          }
        ]
      }
    ]
  },
  {
    "web": "next",
    "feeds": [
      "lihsii47segj"
    ],
    "obras": [
      {
        "id": "next",
        "titulo": "NEXT Neuquen",
        "recorridos": [
          {
            "fecha": "2026-09-12",
            "url": "https://editor.lisual.com/p/next"
          }
        ]
      }
    ]
  },
  {
    "web": "lote360",
    "feeds": [
      "li6xn3bqr4es"
    ],
    "obras": [
      {
        "id": "lote360",
        "titulo": "Lote 360, El Canton (Escobar)",
        "recorridos": [
          {
            "fecha": "2026-09-24",
            "url": "https://editor.lisual.com/p/lote360"
          }
        ]
      }
    ]
  },
  {
    "web": "virazon88",
    "feeds": [
      "fehy5fkfi7uz"
    ],
    "obras": [
      {
        "id": "virazon88",
        "titulo": "Virazon 88, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-09-24",
            "url": "https://editor.lisual.com/p/virazon88"
          }
        ]
      }
    ]
  },
  {
    "web": "virazon122",
    "feeds": [
      "fe0ykvvkw69r"
    ],
    "obras": [
      {
        "id": "virazon122",
        "titulo": "Virazon 122, Nordelta",
        "recorridos": [
          {
            "fecha": "2026-09-24",
            "url": "https://editor.lisual.com/p/virazon122"
          }
        ]
      }
    ]
  },
  {
    "web": "andromaco",
    "feeds": [
      "lidtgzmtqpzu",
      "fexz2trhrqcn",
      "fecaeyw6ytzq"
    ],
    "obras": [
      {
        "id": "andromaco",
        "titulo": "Av. Ing. Huergo 1145, CABA",
        "recorridos": [
          {
            "fecha": "2026-09-24",
            "url": "https://editor.lisual.com/p/andromaco"
          }
        ]
      }
    ]
  },
  {
    "web": "vibraolivos",
    "feeds": [
      "lidfn3emzvc4"
    ],
    "obras": [
      {
        "id": "vibraolivos",
        "titulo": "Vibra Olivos, Vicente Lopez",
        "recorridos": [
          {
            "fecha": "2026-09-24",
            "url": "https://editor.lisual.com/p/vibraolivos"
          }
        ]
      }
    ]
  },
  {
    "web": "santoslugares",
    "feeds": [
      "lis4g5jtboj5",
      "lirudec68w7x",
      "liez21nv6ykl",
      "liam4chjgsvq",
      "li9kx8crj7lt"
    ],
    "obras": [
      {
        "id": "santoslugares",
        "titulo": "Paso bajo nivel Av. America, Santos Lugares",
        "recorridos": [
          {
            "fecha": "2026-09-05",
            "url": "https://editor.lisual.com/p/santoslugares360"
          }
        ]
      }
    ]
  },
  {
    "web": "tenerello",
    "feeds": [
      "feoukxzwbqnl"
    ],
    "obras": [
      {
        "id": "tenerello",
        "titulo": "Estudio Tenerello · Navarro 1",
        "recorridos": [
          {
            "fecha": null,
            "url": "https://editor.lisual.com/p/tenerello"
          }
        ]
      }
    ]
  },
  {
    "web": "onixsinclair",
    "feeds": [
      "li9yiscw2qmc"
    ],
    "obras": [
      {
        "id": "onixsinclair",
        "titulo": "Step Onix Sinclair, Sinclair 2939, Palermo",
        "recorridos": [
          {
            "fecha": "2026-08-22",
            "url": "https://editor.lisual.com/p/onixsinclair360"
          }
        ]
      }
    ]
  },
  {
    "web": "oneescobar",
    "feeds": [
      "liucol396hmh",
      "li1noqn7opyj"
    ],
    "obras": [
      {
        "id": "oneescobar",
        "titulo": "ONE Escobar (renders de la casa)",
        "recorridos": [
          {
            "fecha": null,
            "url": "https://editor.lisual.com/p/oneescobar360"
          }
        ]
      }
    ]
  }
];

/** Obras con recorrido 360 de una cámara (por feedID o identifier), o null si no tiene. */
export function buscarRecorridos({ feedID, identifier } = {}) {
  const claves = [feedID, identifier].filter(Boolean).map((c) => String(c).toLowerCase());
  if (!claves.length) return null;
  const obras = RECORRIDOS_360
    .filter((e) => e.feeds.some((f) => claves.includes(String(f).toLowerCase())))
    .flatMap((e) => e.obras);
  return obras.length ? obras : null;
}
